import { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { Box, ButtonBase, Dialog, InputBase, makeStyles, Popover } from '@material-ui/core';
import { useSelector } from 'react-redux';
import _, { isEqual } from 'lodash';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { CloseIcon, OffIcon, ScanIcon, UpdateIcon } from '../../../components/Icon';
import StyleButton from '../../../components/StyleButton';
import { systemAPI, equipmentAPI } from '../../../apis';
import { authNameE } from '../../../utils/userFuncs';
import useBarcodeListener from '../../../utils/useBarcodeListener';
import { i18n } from '../../../language';
import { EQUIPMENT_STATUS_ENUM, EQUIPMENT_LENGTH, EQUIPMENT_PIE_STATUS_ENUM } from '../../../comm/constant';
import { useScanPage } from '../../../utils/useScanQrcode';
import useMobile from '../../../utils/useMobile';
import {
  VIEW_REQUEST_UPDATE_EQUIPMENT_STATUS,
  UPDATE_EQUIPMENT_STATUS_AVAILABLE,
  UPDATE_EQUIPMENT_STATUS_STAND_BY,
  UPDATE_EQUIPMENT_STATUS_IN_USE,
  UPDATE_EQUIPMENT_STATUS_RETURNING,
  UPDATE_EQUIPMENT_STATUS_NOT_FOR_LOAN,
  UPDATE_EQUIPMENT_STATUS_REPAIRING,
  UPDATE_EQUIPMENT_STATUS_RESERVED,
  UPDATE_EQUIPMENT_STATUS_CONDEMNED,
  UPDATE_EQUIPMENT_STATUS_REPROCESSING,
} from '../../../comm/commandQRcode';
import { AutoCompleteSelect } from '../../../components';
import SnackbarAlert from '../../../components/SnackbarAlert';
import DiaLog from '../../../components/Dialog';
import { initValue } from '../../../utils';
import { ReactComponent as TvIcon } from '../../../static/images/TvIcon.svg';
import DiaLogADS from './DiaLogADS';
import UpdateStatusReminder from './UpdateStatusReminder';

const useStyles = makeStyles(() => ({
  update: {
    // width: '15.938rem',
    height: '3rem',
    backgroundColor: '#28d2ab',
    borderRadius: '10px',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#fff',
    columnGap: '0.5rem',
    padding: '0 1rem',
  },
  offLight: {
    // width: '7.125rem',
    height: '3rem',
    borderRadius: '10px',
    backgroundColor: '#f17a80',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    columnGap: '0.5rem',
    padding: '0 1rem',
  },
  icon: {
    fontSize: '1.5rem',
    color: '#fff',
  },
  confirmDialog: {
    '& .MuiPaper-root': {
      backgroundColor: '#FFFFFF',
      padding: '1.875rem',
      display: 'flex',
      overflowY: 'auto',
      flexDirection: 'column',
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.125rem 1.3125rem rgba(30, 56, 140, 0.18)',
      alignItems: 'center',
    },
  },
  confirmText: {},
  dialog: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 'none',
    },
    '& .MuiPaper-root': {
      backgroundColor: '#FFFFFF',
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.125rem 1.3125rem rgba(30, 56, 140, 0.18)',
      margin: '0',
      width: '67rem',
      height: '45rem',
      padding: '1.625rem',
      display: 'flex',
      overflowY: 'auto',
      flexDirection: 'column',
    },
    '& .MuiAlert-root': {
      padding: '6px 16px',
      flexDirection: 'row',
      fontWeight: '400',
      fontFamily: 'NotoSans-Medium',
    },
    '& .MuiAlert-filledError': {
      width: 'auto',
      height: 'auto',
      backgroundColor: '#f44336',
    },
    '& .MuiPaper-elevation6': {
      boxShadow:
        '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)',
    },
  },
  h1: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    color: '#2e4469',
  },
  h2: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
  },
  star: {
    color: '#ff0300',
  },
  buttonBase: {
    width: '1.5rem',
    height: '1.5rem',
  },
  closeIcon: {
    fontSize: '1rem',
    color: '#538fff',
  },
  inputBase: {
    width: '100%',
    height: '3.5rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    padding: '0 1.25rem',
    fontSize: '1rem',
    color: '#2e4469',
  },
  tableTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    color: '#c0c6cb',
  },
  text: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  subText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#9b9b9b',
  },
  pairPatient: {
    color: '#1973e6',
    fontSize: '1rem',
    fontWeight: '500',
    fontFamily: 'NotoSans-Medium',
    textDecoration: 'underline',
  },
  popover: {
    '& .MuiPopover-paper': {
      width: '22.313rem',
      padding: '1.25rem 1.188rem 0.449rem 1.25rem',
      background: '#fff',
      boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.23)',
      borderRadius: '6px',
      marginTop: '0.3rem',
    },
  },
  patientHNTitle: {
    fontSize: '1rem',
    color: '#2e4469',
    fontWeight: '500',
    fontFamily: 'NotoSans-Medium',
  },
  tableStatus: {
    width: '0.625rem',
    height: '0.625rem',
    borderRadius: '50%',
    backgroundColor: '#34c759',
    marginRight: '0.625rem',
  },
  confirmContent: {
    color: '#2e4469',
    fontSize: '1rem',
  },
  tvIcon: {
    width: '2rem',
    height: '1.4375rem',
  },
  tvDashboardBtn: {
    height: '3rem',
    backgroundColor: '#538FFF',
    borderRadius: '10px',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#fff',
    columnGap: '0.5rem',
    padding: '0 1rem',
  },
}));
// getUpdateEquipment
const UpdateEquipmentStatusDialog = ({ dialogHandler, refreshHandler }) => {
  const initFormData = {
    currentLocation: null,
    equipmentStatus: null,
  };
  const classes = useStyles();
  const ref = useRef(null);
  const loginInfo = useSelector((state) => state.loginInfo);
  const [formData, setFormData] = useState({ ...initFormData, currentLocation: loginInfo.wardId });
  const [assetID, setAssetID] = useState('');
  const [equipmentStatusList, setEquipmentStatusList] = useState();
  const [currentLocationList, setCurrentLocationList] = useState();
  const [barcodeListener] = useState(true);
  const [tableList, setTableList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [patientHNVal, setPatientHNVal] = useState({ assetId: '', value: '' });
  const [barcodeAssetId, setBarcodeAssetId] = useState(true);
  const [barcodePatientHN, setBarcodePatientHN] = useState(false);
  const [isPad] = useMobile();
  const [alertOpen, setAlertOpen] = useState(false);
  const [invalidAssetOpen, setInvalidAssetOpen] = useState(false);
  const [sameStatusOpen, setSameStatusOpen] = useState(false);
  const [diaLogADS, setDiaLogADS] = useState(false);
  const [confirmPop, setConfirmPop] = useState(false);
  const [serviceTypeList, setServiceTypeList] = useState([]);
  const [displayReturnCurrentLocation, setDisplayReturnCurrentLocation] = useState(false);
  const [returnCurrentLocationOptions, setReturnCurrentLocationOptions] = useState([]);
  const [showUpdateStatusReminder, setShowUpdateStatusReminder] = useState(false);
  const [assetReminderIndex, setAssetReminderIndex] = useState(0);
  const [orderInfo, setOrderInfo] = useState(null);
  // 当前表格里的状态
  const tableStatus = _.get(_.last(tableList), 'status');
  // 当前表格里的satellite store
  const tableSatelliteStore = _.get(_.last(tableList), 'categorySatelliteStoresId');
  // 当前表格里的provider
  const tableProvider = _.get(_.last(tableList), 'provideWardId');
  const currentTableProvider = tableSatelliteStore ? `${tableProvider} - ${tableSatelliteStore}` : tableProvider;

  const confirmPopHandler = useCallback((props) => () => {
    setConfirmPop(props);
  });

  // 去重 tableList categoryId
  const tableCategoryIdArr = useMemo(() => {
    return _.uniqWith(_.map(tableList, (item) => item.categoryId));
  }, [tableList]);

  const getADSDataByServiceTypeList = useCallback(
    (serviceTypeList) => {
      let noAdsIdsData = [];
      let noAdsTableData = [];
      if (_.isArray(serviceTypeList)) {
        const serviceTypeHospitalCategoryId = _.map(serviceTypeList, (item) => item.hospitalCategoryId);
        const diff = _.difference(tableCategoryIdArr, serviceTypeHospitalCategoryId);
        noAdsIdsData = diff;
        noAdsTableData = _.filter(tableList, (item) => {
          return noAdsIdsData.includes(item.categoryId);
        });
      }
      return {
        noAdsIdsData,
        noAdsTableData,
      };
    },
    [tableList, tableCategoryIdArr]
  );

  // table data
  const getUpdateEquipmentTable = useCallback(
    async (assetId) => {
      try {
        const { result } = await equipmentAPI.getUpdateEquipment({ assetId: assetId });
        // 输入重复的asset id出提示
        if (_.isArray(tableList)) {
          _.map(tableList, (item, index) => {
            if (assetId === item.assetId) {
              setAlertOpen(true);
            }
          });
          let firstStatus;
          let firstSatelliteStore;
          if (tableList.length > 0) {
            // 输入的asset id 必须是相同状态,并且如果有satellite store，需要satellite store也要相同
            firstStatus = tableList[0].status;
            firstSatelliteStore = tableList[0].categorySatelliteStoresId;
            if (firstStatus !== result.status || firstSatelliteStore !== result.categorySatelliteStoresId) {
              setSameStatusOpen(true);
              setAssetID('');
              return;
            }
          }
          tableList.push(result);
        }
        const filterData = _.uniqWith(tableList, isEqual);
        setTableList((pre) => {
          return [...filterData];
        });
        setAssetID('');
      } catch (error) {
        console.log(error);
        setAssetID('');
      }
    },
    [tableList]
  );

  // asset ID scan Equipment
  const getEquipment = useCallback((assetId) => {
    (async () => {
      await getUpdateEquipmentTable(assetId);
    })();
  }, []);
  const getPatientHN = useCallback((e) => {
    setPatientHNVal((pre) => {
      return {
        ...pre,
        value: e,
      };
    });
  }, []);
  // change Equipment status
  const changeStatus = useCallback((e) => {
    switch (e) {
      case UPDATE_EQUIPMENT_STATUS_AVAILABLE:
        changeHandler('equipmentStatus')(1);
        break;
      case UPDATE_EQUIPMENT_STATUS_STAND_BY:
        changeHandler('equipmentStatus')(3);
        break;
      case UPDATE_EQUIPMENT_STATUS_IN_USE:
        changeHandler('equipmentStatus')(4);
        break;
      case UPDATE_EQUIPMENT_STATUS_RETURNING:
        changeHandler('equipmentStatus')(5);
        break;
      case UPDATE_EQUIPMENT_STATUS_NOT_FOR_LOAN:
        changeHandler('equipmentStatus')(6);
        break;
      case UPDATE_EQUIPMENT_STATUS_REPAIRING:
        changeHandler('equipmentStatus')(7);
        break;
      case UPDATE_EQUIPMENT_STATUS_RESERVED:
        changeHandler('equipmentStatus')(8);
        break;
      case UPDATE_EQUIPMENT_STATUS_CONDEMNED:
        changeHandler('equipmentStatus')(9);
        break;
      case UPDATE_EQUIPMENT_STATUS_REPROCESSING:
        changeHandler('equipmentStatus')(10);
        break;
      default:
        break;
    }
  }, []);
  // Scan Equipment 的組件和調用函數,返回第一個是組件，第二個是開啟的函數
  const [ScanPortal, openScanPage] = useScanPage(getEquipment);
  // Patient HN
  const [ScanPortalPatientHN, openScanPagePatientHN] = useScanPage(getPatientHN);
  // Scan Equipment status
  const [ScanPortalStatus, openScanPageStatus] = useScanPage(changeStatus);
  // delete table list
  const delListItem = (rowData) => {
    setFormData((preData) => ({ ...preData, equipmentStatus: '' }));
    const idx = tableList.findIndex((item) => item.assetId === rowData.assetId);
    _.pullAt(tableList, idx);
    if (tableList.length > 0) {
      setTableList((pre) => [...tableList]);
    } else {
      setTableList([]);
    }
  };
  // Equipment Status Option
  const equipmentStatusOption = useMemo(() => {
    let equipmentStatus = [];
    if (_.isArray(equipmentStatusList)) {
      equipmentStatus = _.map(equipmentStatusList, (item) => ({
        text: i18n.t(
          _.find(EQUIPMENT_PIE_STATUS_ENUM, (statusItem) => statusItem.enumKey === item.id)?.textKey ??
            'EQUIPMENT_VIEWREQUEST_BLANK'
        ),
        value: item.id,
      }));
    }
    return equipmentStatus;
  }, [equipmentStatusList]);

  // get Current Location list
  const getWardList = useCallback(async () => {
    try {
      const { result } = await systemAPI.getSysHospitalWardList({ hospitalId: loginInfo.hospitalId, wardId: null });
      setCurrentLocationList(result?.[0]?.wards);
    } catch (error) {
      console.log(error);
    }
  }, [loginInfo]);

  // 控制 current location 的禁用, 原始 status 不是黄色状态的时候才可以修改
  const disabledCurrentLocation =
    _.some([2, 3, 4, 5], (item) => item === tableStatus) || loginInfo.wardId !== tableProvider;

  // 表格里的状态是available的时候可用
  // tableStatus === EQUIPMENT_STATUS_ENUM.AVAILABLE.enumKey ||
  // 表格里的状态是returning，且provider是当前ward的时候可用
  // (tableStatus === EQUIPMENT_STATUS_ENUM.RETURNING.enumKey && tableProvider === loginInfo.wardId);

  const getcurrentLocationText = (wardName, roomName) => {
    return roomName ? `${wardName}-${roomName}` : wardName;
  };

  // Current Location Option
  const currentLocationOption = useMemo(() => {
    let currentLocationOptions = [];
    let satelliteStoreOptions = [];
    const equipmentInfo = _.last(tableList) ?? {};
    const categoryId = equipmentInfo?.categoryId ?? '';
    const roomName = equipmentInfo?.roomName ?? '';
    const wardId = equipmentInfo?.wardId ?? '';

    if (_.isArray(currentLocationList)) {
      currentLocationOptions = _.map(currentLocationList, (item) => ({
        text: item.wardId === wardId ? getcurrentLocationText(item.wardName, roomName) : item?.wardName,
        value: item.wardId,
        currentLocation: item.wardId,
        categorySatelliteStoresId: null,
      }));
    }
    if (!disabledCurrentLocation) {
      currentLocationOptions = _.filter(currentLocationOptions, (item) => item.value === loginInfo.wardId);
    }
    if (_.isArray(serviceTypeList)) {
      satelliteStoreOptions = _.map(
        serviceTypeList.filter((item) => item.hospitalCategoryId === categoryId), // 筛选当前设备类型的 satellite store
        (item) => ({
          text: `    ${item.satelliteStoresName}`,
          value: `${loginInfo.wardId} - ${item.categorySatelliteStoresId}`,
          currentLocation: loginInfo.wardId,
          categorySatelliteStoresId: item.categorySatelliteStoresId,
        })
      );
      currentLocationOptions = _.concat(currentLocationOptions, satelliteStoreOptions);
    }
    return currentLocationOptions;
  }, [currentLocationList, loginInfo.wardId, serviceTypeList, disabledCurrentLocation, tableList]);

  // 当前选择的location
  const currentSelectedLocation = _.find(currentLocationOption, (item) => item.value === formData.currentLocation);
  const currentSelectedCategorySatelliteStoresId = _.get(currentSelectedLocation, 'categorySatelliteStoresId');
  const currentLocationValue = _.get(currentSelectedLocation, 'currentLocation');
  const currentLocationText = _.get(currentSelectedLocation, 'text');
  // 原本的 categorySatelliteStoresId
  const categorySatelliteStoresId = !disabledCurrentLocation ? tableList?.[0]?.categorySatelliteStoresId : null;
  // 修改之后的 categorySatelliteStoresId
  const transferSatelliteStoresId = !disabledCurrentLocation ? currentSelectedCategorySatelliteStoresId : null;
  const firstItem = _.first(tableList);
  const isCSSD = Boolean(firstItem?.returnDesignateRoom);
  // CSSD的时候还回去
  const isCssdReturnSatelliteStore = isCSSD && firstItem.categorySatelliteStoresId === categorySatelliteStoresId;

  // 切换 Equipment Status
  const changeHandler = (key) => {
    return (value) => {
      setFormData((preData) => ({ ...preData, [key]: value }));
    };
  };
  // update 表单
  const updateEquipmentAPi = async (statusType, tableListData, hasUpdateHN) => {
    console.log('tableListData', tableListData);
    try {
      let params = {
        equipments: initValue(tableListData, tableList),
        status: formData.equipmentStatus,
        wardId: loginInfo.wardId,
        currentLocation: currentLocationValue,
        categorySatelliteStoresId: initValue(tableListData, tableList)[0].categorySatelliteStoresId,
        transferSatelliteStoresId,
        ...(hasUpdateHN ? { status: null } : null),
      };
      if (orderInfo) {
        params.isDeleteAdsOrder = ['A', 'C'].includes(orderInfo?.returnOrderStatus) ? false : true;
      }

      await equipmentAPI.updateEquipmentStatus(params);
      if (statusType === 'returning') {
        confirmPopHandler(tableList.length === 0)();
        setDiaLogADS(tableListData === undefined);
      }
      if (statusType !== 'returning' && orderInfo === null) {
        dialogHandler(false)();
      }
      refreshHandler();
    } catch (error) {
      console.log(error);
    }
  };

  // getServiceTypeAPi
  const getServiceTypeAPi = useCallback(async () => {
    try {
      let params = {
        hospitalCategoryIds: tableCategoryIdArr,
      };
      const { result } = await equipmentAPI.getServiceType(params);
      return getADSDataByServiceTypeList(result?.CategoryServiceType);
    } catch (error) {
      console.log(error, 'error');
    }
  }, [getADSDataByServiceTypeList, tableCategoryIdArr]);

  const updateEquipmentStatusBtn = async () => {
    // multipleEquipment为0弹出pop-up， 为1则不用弹
    const multipleEquipmentstatus = _.some(tableList, { multipleEquipment: 0 });
    if (multipleEquipmentstatus) {
      confirmPopHandler(true)();
    } else {
      //  update equipment status to “returning”
      if (formData?.equipmentStatus === 5) {
        const { noAdsIdsData, noAdsTableData } = await getServiceTypeAPi();
        if (noAdsTableData?.length > 0) {
          await updateEquipmentAPi('returning', noAdsTableData);
        }
        setTableList(() => {
          const list = _.filter(tableList, (item) => {
            return !noAdsIdsData.includes(item.categoryId);
          });
          setDiaLogADS(list.length > 0);
          return list;
        });
        return;
      }

      // update equipment status to "in use" / "stand by" from "returning"
      if ([3, 4].includes(formData?.equipmentStatus)) {
        getAdsOrderInfo(assetReminderIndex);
        return;
      }

      if (transferSatelliteStoresId !== categorySatelliteStoresId || isCssdReturnSatelliteStore) {
        confirmPopHandler(false)();
        setDiaLogADS(true);
        return;
      }
      confirmPopHandler(false)();
      await updateEquipmentAPi();
    }
  };

  const getAdsOrderInfo = async (assetReminderIndex) => {
    try {
      const currentAsset = tableList[assetReminderIndex];
      // 当设备的当前的status是Returning的时候才会走return ads order的流程，其他状态就直接更新
      if (currentAsset?.status === 5) {
        const params = {
          assetId: currentAsset?.assetId ?? '',
          hospCode: currentAsset?.hospCode ?? '',
        };
        const { result } = await equipmentAPI.returnAdsOrder(params);
        if (result !== null && JSON.stringify(result) !== '{}') {
          const orderInfo = {
            returnOrderStatus: result.returnOrderStatus,
            returnOrderNo: result.returnOrderNo,
          };
          setOrderInfo(orderInfo);
          setShowUpdateStatusReminder(true);
        } else {
          await updateEquipmentAPi();
        }
      } else {
        await updateEquipmentAPi();
      }
    } catch (error) {
      console.log('error: ', error);
    }
  };

  const reminderPopupConfirm = async () => {
    await updateEquipmentAPi('', [tableList[assetReminderIndex]]);
    setTableList((pre) => {
      return _.filter(pre, (item) => item?.assetId !== tableList[assetReminderIndex]?.assetId);
    });

    if (assetReminderIndex < tableList.length - 1) {
      setAssetReminderIndex(assetReminderIndex + 1);
      getAdsOrderInfo(assetReminderIndex + 1);
    } else {
      setAssetReminderIndex(0);
      setShowUpdateStatusReminder(false);
      setOrderInfo(null);
      dialogHandler(false)();
    }
  };

  const reminderPopupCancel = () => {
    setAssetReminderIndex(0);
    setShowUpdateStatusReminder(false);
    setOrderInfo(null);
  };

  const confirmBtn = useCallback(async () => {
    if (formData.equipmentStatus === 5) {
      const { noAdsIdsData, noAdsTableData } = await getServiceTypeAPi();
      if (noAdsIdsData.length > 0) {
        await updateEquipmentAPi('returning', noAdsTableData, false);
        setTableList(() => {
          const list = _.filter(tableList, (item) => {
            return !noAdsIdsData.includes(item.categoryId);
          });
          dialogHandler(list.length !== 0)();
          return list;
        });
      }
      if (noAdsTableData.length === 0 && tableList.length > 0) {
        await updateEquipmentAPi('returning', undefined, true);
      }
    } else {
      await updateEquipmentAPi();
    }
  }, [formData, getServiceTypeAPi, tableList]);

  // 監聽 barcode 槍切换 Equipment Status
  useBarcodeListener((e) => {
    switch (e) {
      case UPDATE_EQUIPMENT_STATUS_AVAILABLE:
        changeHandler('equipmentStatus')(1);
        break;
      case UPDATE_EQUIPMENT_STATUS_STAND_BY:
        changeHandler('equipmentStatus')(3);
        break;
      case UPDATE_EQUIPMENT_STATUS_IN_USE:
        changeHandler('equipmentStatus')(4);
        break;
      case UPDATE_EQUIPMENT_STATUS_RETURNING:
        changeHandler('equipmentStatus')(5);
        break;
      case UPDATE_EQUIPMENT_STATUS_NOT_FOR_LOAN:
        changeHandler('equipmentStatus')(6);
        break;
      case UPDATE_EQUIPMENT_STATUS_REPAIRING:
        changeHandler('equipmentStatus')(7);
        break;
      case UPDATE_EQUIPMENT_STATUS_RESERVED:
        changeHandler('equipmentStatus')(8);
        break;
      case UPDATE_EQUIPMENT_STATUS_CONDEMNED:
        changeHandler('equipmentStatus')(9);
        break;
      case UPDATE_EQUIPMENT_STATUS_REPROCESSING:
        changeHandler('equipmentStatus')(10);
        break;
      default:
        break;
    }
  }, barcodeListener);

  // barcode枪 Asset ID
  useBarcodeListener((e) => {
    setBarcodePatientHN(false);
    if (
      e !== UPDATE_EQUIPMENT_STATUS_AVAILABLE &&
      e !== UPDATE_EQUIPMENT_STATUS_STAND_BY &&
      e !== UPDATE_EQUIPMENT_STATUS_IN_USE &&
      e !== UPDATE_EQUIPMENT_STATUS_RETURNING &&
      e !== UPDATE_EQUIPMENT_STATUS_NOT_FOR_LOAN &&
      e !== UPDATE_EQUIPMENT_STATUS_REPAIRING &&
      e !== UPDATE_EQUIPMENT_STATUS_RESERVED &&
      e !== UPDATE_EQUIPMENT_STATUS_CONDEMNED &&
      e !== UPDATE_EQUIPMENT_STATUS_REPROCESSING
    ) {
      setAssetID(e);
      (async () => {
        await getUpdateEquipmentTable(e);
      })();
    }
  }, barcodeAssetId);
  //  Asset ID onChange
  const inputHandler = (event) => {
    setAssetID(event.target.value);
    setAlertOpen(false);
    setInvalidAssetOpen(false);
    setSameStatusOpen(false);
  };
  // Enter  asset Id
  const onKeyDownHandler = (event) => {
    if (event.code === 'Enter' || event.code === 'NumpadEnter') {
      (async () => {
        await getUpdateEquipmentTable(event.target.value);
      })();
    }
  };
  // Asset ID 获取焦点
  const inputOnFocus = () => {
    setBarcodeAssetId(false);
  };
  // Asset ID 失去焦点
  const inputOnBlur = () => {
    setBarcodeAssetId(true);
  };
  // Equipment Status list Api
  const getEquipmentStatusList = useCallback(async () => {
    if (tableList.length > 0) {
      try {
        // 拿第一个设备的status
        let currentStatus, assetId;
        if (_.isArray(tableList)) {
          currentStatus = tableList[0].status;
          assetId = tableList[0].assetId;
        } else {
          currentStatus = tableList.status;
          assetId = tableList.assetId;
        }
        const { result } = await equipmentAPI.getEquipmentStatus({
          wardId: loginInfo.wardId,
          currentStatus: currentStatus,
          assetId: assetId,
        });
        setEquipmentStatusList(result.status);
      } catch (error) {
        console.log(error);
      }
    } else {
      setEquipmentStatusList('');
    }
  }, [loginInfo, tableList]);

  useEffect(() => {
    (async () => {
      await getEquipmentStatusList();
    })();
    (async () => {
      await getWardList();
    })();
  }, [tableList]);
  // open Patient HN Popover
  const handleClick = (event, rowData) => {
    setPatientHNVal({
      assetId: rowData.assetId,
      value: rowData.patientNo || '',
    });
    setAnchorEl(event.currentTarget);
    setBarcodeAssetId(false);
    setBarcodePatientHN(true);
  };
  // close Patient HN Popover
  const handleClose = () => {
    setAnchorEl(null);
    setBarcodeAssetId(true);
    setBarcodePatientHN(false);
  };
  // Done Patient HN Popover
  const handleDone = () => {
    const idx = tableList.findIndex((it) => it.assetId === patientHNVal.assetId);
    if (idx > -1) {
      setTableList((p) => {
        p[idx].patientNo = patientHNVal.value;
        return [...p];
      });
    }
    setAnchorEl(null);
    setBarcodeAssetId(true);
    setBarcodePatientHN(false);
  };
  const inputPatientHNValHandler = (event) => {
    setPatientHNVal((pre) => {
      return {
        ...pre,
        value: event.target.value,
      };
    });
  };
  // 判断输入的值是否HN开头
  const patientHNValue = (e) => {
    setPatientHNVal((pre) => {
      return {
        ...pre,
        value: e.target ? e.target.value.replace(/\s*/g, '') : e.replace(/\s*/g, ''),
      };
    });
  };
  // barcode枪 Patient HN
  useBarcodeListener((e) => {
    patientHNValue(e);
    setBarcodeAssetId(false);
  }, barcodePatientHN);
  // Patient HN 失去焦点
  const inputPatientHNBlur = (event) => {
    patientHNValue(event);
  };
  const patientHN = () => {
    return (
      <Popover
        open={Boolean(anchorEl)}
        className={classes.popover}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <ScanPortalPatientHN />
        <Box display="flex" justifyContent="space-between" mb="0.375rem">
          <div className={classes.patientHNTitle}>{i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_PATIENT_HN')}</div>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb="0.75rem" gridColumnGap="1rem">
          <InputBase
            className={classes.inputBase}
            placeholder={i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_PATIENT_HN_PLACEHOLDER')}
            value={patientHNVal.value}
            onChange={inputPatientHNValHandler}
            ref={ref}
            onBlur={inputPatientHNBlur}
            inputProps={{ maxLength: EQUIPMENT_LENGTH.REQUEST_HN }}
            id="patient-HN"
          />

          {isPad && (
            <StyleButton
              className={classes.scanButton}
              width="3.75rem"
              Icon={ScanIcon}
              iconStyle={{ fontSize: '1.5rem' }}
              onClick={() => {
                (async () => {
                  await openScanPagePatientHN();
                })();
              }}
              id="scan-patient-btn"
            />
          )}
        </Box>
        <Box display="flex" mt="0.75rem" gridColumnGap="0.75rem" justifyContent="flex-end" mb="1.25rem">
          <StyleButton
            text={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_CANCEL')}
            width="7.5rem"
            onClick={handleClose}
          />
          <StyleButton
            text={i18n.t('EQUIPMENT_DONE')}
            type="fill"
            backgroundColor="#4c93ff"
            width="7.5rem"
            onClick={handleDone}
          />
        </Box>
      </Popover>
    );
  };
  const closeMyAlert = () => {
    setAlertOpen(false);
  };
  const closeInvalidAssetOpen = () => {
    setInvalidAssetOpen(false);
  };
  const closeSameStatusOpen = () => {
    setSameStatusOpen(false);
  };
  const currentLocation = useMemo(() => {
    // 表格里添加设备的satellite store id
    const firstSatelliteStore = _.get(_.last(tableList), 'categorySatelliteStoresId');
    const provideWardId = _.get(_.last(tableList), 'provideWardId');

    if (formData.equipmentStatus === 3 || formData.equipmentStatus === 4 || formData.equipmentStatus === 5) {
      // 当更换成借出去的状态，当前位置变成申请的病房
      const tableLocation = firstSatelliteStore ? `${provideWardId} - ${firstSatelliteStore}` : provideWardId;
      return tableLocation === formData.currentLocation ? _.get(_.last(tableList), 'wardId') : formData.currentLocation;
    }
    if (tableList.length === 1 && loginInfo.wardId === provideWardId) {
      // 当输入的是satellite store的设备的时候自动选择当前ward
      return firstSatelliteStore ? `${loginInfo.wardId} - ${firstSatelliteStore}` : loginInfo.wardId;
    }
    return formData.currentLocation;
  }, [formData.equipmentStatus, tableList, disabledCurrentLocation, loginInfo]);

  // 转回 formData 里面控制
  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      currentLocation,
    }));
  }, [currentLocation]);

  useEffect(() => {
    // 借出去的状态
    const onLoanStatus = [2, 3, 4, 5];
    // 判断当前表格数据里的状态是不是已借出
    const tableStatusIsOnLoan = _.some(onLoanStatus, (item) => item === tableStatus);

    if (tableStatusIsOnLoan && _.some([1, 10], (item) => item === formData.equipmentStatus)) {
      // 如果表格数据的状态是已借出，并且当前选择的状态是可用或者待处理，则用returnCurrentLocation显示，没有则用回Provider
      setFormData((prevData) => ({
        ...prevData,
        currentLocation: currentTableProvider,
      }));
      setDisplayReturnCurrentLocation(true);
      const equipmentItem = _.last(tableList);
      const returnCurrentLocation = _.get(equipmentItem, 'returnCurrentLocation');
      // 表格中的Provider 显示
      const equipmentProvider = equipmentItem.satelliteStoresName
        ? `${equipmentItem.wardName}(${equipmentItem.satelliteStoresName})`
        : equipmentItem.wardName;
      setReturnCurrentLocationOptions([
        {
          text: returnCurrentLocation ?? equipmentProvider,
          value: currentTableProvider,
          categorySatelliteStoresId: equipmentItem.categorySatelliteStoresId ?? null,
        },
      ]);
    } else {
      setDisplayReturnCurrentLocation(false);
    }
  }, [tableList, tableStatus, formData.equipmentStatus, loginInfo, currentTableProvider]);

  const dialogADSHandler = (props) => () => {
    setDiaLogADS(props);
  };

  const getSatelliteStores = async () => {
    try {
      const { result } = await equipmentAPI.getSatelliteStores();
      setServiceTypeList(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSatelliteStores();
  }, []);

  const disabled = _.some(
    tableList,
    (item) => item.wardId !== currentLocationValue && item.provideWardId !== currentLocationValue
  );

  const getCurrentLocationText = (equipmentItem) => {
    if (equipmentItem?.returnDesignateRoom !== null) return equipmentItem?.returnDesignateRoom;
    const wardName = equipmentItem?.roomName
      ? `${equipmentItem?.wardName}-${equipmentItem?.roomName}`
      : equipmentItem?.wardName;

    return !disabledCurrentLocation && equipmentItem?.satelliteStoresName
      ? `${equipmentItem?.wardName}(${equipmentItem?.satelliteStoresName})`
      : wardName;
  };

  return (
    <>
      <Dialog open={true} className={classes.dialog}>
        <SnackbarAlert
          openAlert={alertOpen}
          text={i18n.t('EQUIPMENT_DUPLICATE_ASSET_ID')}
          onClose={closeMyAlert}
          type="error"
        />
        <SnackbarAlert
          openAlert={invalidAssetOpen}
          text={i18n.t('EQUIPMENT_INVALID_ASSET_ID')}
          onClose={closeInvalidAssetOpen}
          type="error"
        />
        <SnackbarAlert
          openAlert={sameStatusOpen}
          text={i18n.t('EQUIPMENT_SAME_STATUS')}
          onClose={closeSameStatusOpen}
          type="error"
        />
        <ScanPortal />
        <Box display="flex" justifyContent="space-between" mb="1.332rem">
          <div className={classes.h1}>{i18n.t('EQUIPMENT_UPDATE_STATUS')}</div>
          <ButtonBase className={classes.buttonBase} onClick={dialogHandler(false)}>
            <CloseIcon className={classes.closeIcon} />
          </ButtonBase>
        </Box>
        <div className={classes.h2}>
          {i18n.t('EQUIPMENT_UPDATE_ASSET_ID')}
          <span className={classes.star}> *</span>
        </div>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mt="0.688rem"
          mb="2rem"
          gridColumnGap="1.25rem"
        >
          <InputBase
            className={classes.inputBase}
            placeholder={i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_ASSET_ID_PLACEHOLDER')}
            value={assetID}
            onKeyDown={onKeyDownHandler}
            onChange={inputHandler}
            onFocus={inputOnFocus}
            onBlur={inputOnBlur}
            id="asset-id-input"
          />
          {isPad && (
            <StyleButton
              className={classes.scanButton}
              width="14.125rem"
              text={i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_SCAN_EQUIPMENT')}
              Icon={ScanIcon}
              iconStyle={{ fontSize: '1.5rem', marginRight: '0.75rem' }}
              onClick={openScanPage}
              id="asset-id-scan-btn"
            />
          )}
        </Box>
        <Box display="flex" flexDirection="column" gridRowGap="0.75rem" minHeight="17rem" overflow="auto">
          <Box display="flex" padding="0 1rem" alignItems="center" justifyContent="space-between">
            <Box className={classes.tableTitle} flexBasis="11.5%">
              {i18n.t('EQUIPMENT_VIEWREQUEST_ASSET_ID')}
            </Box>
            <Box className={classes.tableTitle} flexBasis="23%">
              <Box display="flex" flexDirection="column">
                <div> {i18n.t('EQUIPMENT_EQUIPMENT_CATEGORY')}/</div>
                <div> {i18n.t('EQUIPMENT_MODEL')}</div>
              </Box>
            </Box>
            <Box className={classes.tableTitle} flexBasis="12.5%">
              {i18n.t('EQUIPMENT_LOCAL_CODE')}
            </Box>
            <Box className={classes.tableTitle} flexBasis="15%">
              <Box display="flex" flexDirection="column">
                <div>{i18n.t('EQUIPMENT_CURRENT_LOCATION')}</div>
              </Box>
            </Box>
            <Box className={classes.tableTitle} flexBasis="12.5%">
              {i18n.t('EQUIPMENT_STATUS')}
            </Box>
            <Box className={classes.tableTitle} flexBasis="12.4%">
              {i18n.t('EQUIPMENT_PATIENT_HN')}
            </Box>
            <Box className={classes.tableTitle} flexBasis="11.6%">
              {i18n.t('EQUIPMENT_PROVIDER')}
            </Box>
            <Box className={classes.tableTitle} flexBasis="2.3%" />
          </Box>
          {tableList.map((equipmentItem, equipmentIndex) => (
            <Box
              display="flex"
              padding="0.5rem 1rem"
              border="solid 1px #e6e7e8"
              borderRadius="6px"
              alignItems="center"
              justifyContent="space-between"
              key={equipmentItem.assetId}
            >
              <Box flexBasis="11.5%">
                <div className={classes.text}> {equipmentItem.assetId}</div>
              </Box>
              <Box flexBasis="23%">
                <Box display="flex" flexDirection="column" gridRowGap="0.5rem">
                  {equipmentItem.categoryName && <div className={classes.text}> {equipmentItem.categoryName}</div>}
                  {equipmentItem.model && <div className={classes.subText}> {equipmentItem.model}</div>}
                </Box>
              </Box>
              <Box flexBasis="12.5%">
                <div className={classes.text}> {equipmentItem.localCode}</div>
              </Box>
              <Box flexBasis="15%">
                <div className={classes.text}>{getCurrentLocationText(equipmentItem)}</div>
              </Box>
              <Box flexBasis="12.5%">
                {_.find(EQUIPMENT_STATUS_ENUM, (item) => item.enumKey === equipmentItem.status) && (
                  <div className={classes.text}>
                    <Box display="flex" alignItems="center">
                      <div
                        className={classes.tableStatus}
                        style={{
                          backgroundColor: _.find(
                            EQUIPMENT_STATUS_ENUM,
                            (item) => item.enumKey === equipmentItem.status
                          ).color,
                        }}
                      />
                      {i18n.t(_.find(EQUIPMENT_STATUS_ENUM, (item) => item.enumKey === equipmentItem.status).textKey)}
                    </Box>
                  </div>
                )}
              </Box>
              <Box flexBasis="12.4%">
                <div
                  className={classes.text}
                  style={{ maxWidth: '7rem', whiteSpace: 'pre-line', wordBreak: 'break-word' }}
                >
                  {equipmentItem.patientUsable === 1 ? (
                    equipmentItem.patientNo
                  ) : (
                    <ButtonBase
                      className={classes.pairPatient}
                      onClick={(e) => handleClick(e, equipmentItem)}
                      id={`pair-patient-${equipmentIndex}`}
                    >
                      {equipmentItem.patientNo ? equipmentItem.patientNo : i18n.t('EQUIPMENT_PAIR_PATIENT')}
                    </ButtonBase>
                  )}
                </div>
              </Box>
              <Box flexBasis="11.6%">
                <div className={classes.text}>
                  {`${equipmentItem.provideWardName}${
                    equipmentItem.satelliteStoresName ? `(${equipmentItem.satelliteStoresName})` : ''
                  }`}
                </div>
              </Box>
              <Box flexBasis="2.3%">
                <ButtonBase
                  className={classes.buttonBase}
                  onClick={() => delListItem(equipmentItem)}
                  id={`delete-${equipmentIndex}`}
                >
                  <CloseIcon className={classes.closeIcon} />
                </ButtonBase>
              </Box>
            </Box>
          ))}
        </Box>
        <Box display="flex" mt="1.5rem" pb="1.5rem" gridColumnGap="1.25rem" borderBottom="solid 1px #e6e7e8">
          <Box display="flex" flexDirection="column" gridRowGap="1rem" flexBasis="50%">
            <div className={classes.h2}>{i18n.t('EQUIPMENT_CURRENT')}</div>
            <AutoCompleteSelect
              id="current-location-select"
              placeholder={i18n.t('SETTING_SELECT_FROM_BELOW')}
              value={formData.currentLocation}
              itemList={displayReturnCurrentLocation ? returnCurrentLocationOptions : currentLocationOption}
              onChange={changeHandler('currentLocation')}
              disabled={disabledCurrentLocation}
              whiteSpace
            />
          </Box>
          <Box display="flex" flexDirection="column" gridRowGap="1rem" flexBasis="32.2%" flex="1">
            <div className={classes.h2}>{i18n.t('EQUIPMENT_STATUS_STATUS')}</div>
            <AutoCompleteSelect
              id="equipment-status-select"
              placeholder={i18n.t('SETTING_SELECT_FROM_BELOW')}
              value={formData.equipmentStatus}
              itemList={equipmentStatusOption}
              onChange={changeHandler('equipmentStatus')}
              noOptionsText={<div>{i18n.t('COMMON_NO_OPTIONS')}</div>}
            />
          </Box>
          <ScanPortalStatus />
          {isPad && (
            <Box display="flex" flexDirection="column-reverse" pb="0.25rem" flexBasis="23.1%">
              <StyleButton
                className={classes.scanButton}
                width="14.125rem"
                text={i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_SCAN_EQUIPMENT')}
                Icon={ScanIcon}
                iconStyle={{ fontSize: '1.5rem', marginRight: '0.75rem' }}
                onClick={openScanPageStatus}
                id="status-scan-btn"
              />
            </Box>
          )}
        </Box>
        <Box display="flex" flexDirection="row-reverse" mt="0.813rem" gridColumnGap="0.75rem">
          <StyleButton
            text={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_CONFIRM')}
            type="fill"
            backgroundColor="#28d2ab"
            width="13.75rem"
            onClick={updateEquipmentStatusBtn}
            disabled={disabled}
          />
          <StyleButton
            text={i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_CANCEL')}
            width="13.75rem"
            onClick={dialogHandler(false)}
          />
        </Box>
        {patientHN()}
      </Dialog>
      {confirmPop && (
        <UpdateConfirmPop confirmPopHandler={confirmPopHandler} confirmBtn={confirmBtn} formData={formData} />
      )}
      {diaLogADS && (
        <DiaLogADS
          dialogADSHandler={dialogADSHandler}
          tableList={tableList}
          setTableList={setTableList}
          handleClose={dialogADSHandler(false)}
          handleCloseUpdateEquipmentStatus={dialogHandler(false)}
          formData={formData}
          setFormData={setFormData}
          currentLocation={currentLocationValue}
          transferSatelliteStoresId={transferSatelliteStoresId}
          categorySatelliteStoresId={categorySatelliteStoresId}
          currentLocationText={currentLocationText}
          isCssdReturnSatelliteStore={isCssdReturnSatelliteStore}
        />
      )}
      {showUpdateStatusReminder && (
        <UpdateStatusReminder
          open={showUpdateStatusReminder}
          handleConfirm={reminderPopupConfirm}
          handleCancel={reminderPopupCancel}
          orderInfo={orderInfo}
        />
      )}
    </>
  );
};

const UpdateEquipmentStatus = ({ refresh, refreshHandler, setStopRefresh, setBarcodeListener, displayTvDashboard }) => {
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = useState(false);
  const loginInfo = useSelector((state) => state.loginInfo);
  const roleMap = useSelector((state) => state.roleMap);
  const [barcodeListenerCtrl, setBarcodeListenerCtrl] = useState(true);
  const [alarmOfDisplay, setAlarmOfDisplay] = useState(false);
  const history = useHistory();

  const offLightAPI = useCallback(async () => {
    try {
      await equipmentAPI.offLight({ wardId: loginInfo.wardId });
    } catch (error) {
      console.log(error);
    }
  }, [loginInfo]);

  const dialogHandler = useCallback(
    (props) => () => {
      setDialogOpen(props);
      setBarcodeListenerCtrl(!props);
      // 暫停刷新計時器
      setStopRefresh(props);
    },
    []
  );

  // open Update Equipment Status pop-up
  useBarcodeListener((e) => {
    if (roleMap[authNameE.equipment_update_equipment_status_requestor_ward_owner_ward]) {
      if (e === VIEW_REQUEST_UPDATE_EQUIPMENT_STATUS) {
        setDialogOpen(true);
        setBarcodeListenerCtrl(false);
      } else {
        setDialogOpen(false);
      }
    }
  }, barcodeListenerCtrl);

  const getAlarmOfDisplay = async () => {
    try {
      const result = await equipmentAPI.getAlarmDisplay(
        { wardId: loginInfo.wardId, hospId: null },
        { isHideLoading: true }
      );
      setAlarmOfDisplay(result.result.isDisplay);
    } catch (error) {
      console.log(error, 'error');
    }
  };

  useEffect(() => {
    setBarcodeListener(!dialogOpen);
  }, [dialogOpen]);

  useEffect(() => {
    (async () => {
      await getAlarmOfDisplay();
    })();
  }, [loginInfo, refresh]);

  return (
    <>
      <Box display="flex" gridColumnGap="0.75rem">
        {displayTvDashboard && (
          <ButtonBase
            id="display-equipment-status"
            className={classes.tvDashboardBtn}
            onClick={() => history.push('/equipmentTvDashboard')}
          >
            <TvIcon className={classes.tvIcon} /> TV Dashboard
          </ButtonBase>
        )}
        {roleMap[authNameE.equipment_alarm_off] && alarmOfDisplay ? (
          <ButtonBase
            id="alarm-off"
            className={classes.offLight}
            onClick={() => {
              (async () => {
                await offLightAPI();
              })();
            }}
          >
            <OffIcon className={classes.icon} /> {i18n.t('EQUIPMENT_OFF_LIGHT')}
          </ButtonBase>
        ) : null}
        {roleMap[authNameE.equipment_update_equipment_status_requestor_ward_owner_ward] && (
          <ButtonBase id="update-equipment-status" className={classes.update} onClick={dialogHandler(true)}>
            <UpdateIcon className={classes.icon} /> {i18n.t('EQUIPMENT_UPDATE_STATUS')}
          </ButtonBase>
        )}
      </Box>
      {dialogOpen && <UpdateEquipmentStatusDialog dialogHandler={dialogHandler} refreshHandler={refreshHandler} />}
    </>
  );
};
const UpdateConfirmPop = ({ confirmPopHandler, confirmBtn }) => {
  const classes = useStyles();
  const confirmUpdateBtn = useCallback(() => {
    confirmBtn();
  }, [confirmBtn]);
  return (
    <DiaLog
      title={i18n.t('EQUIPMENT_CONFIRM_TITLE')}
      cancel={i18n.t('EQUIPMENT_CONFIRM_CANCEL')}
      confirm={i18n.t('EQUIPMENT_CONFIRM_OK')}
      open={true}
      handleCancel={confirmPopHandler(false)}
      handleClose={confirmPopHandler(false)}
      handleConfirm={confirmUpdateBtn}
    >
      <div className={classes.confirmContent}> {i18n.t('EQUIPMENT_CONFIRM_TEXT')}</div>
    </DiaLog>
  );
};

export default UpdateEquipmentStatus;
